module.exports = __webpack_public_path__ + "img/990RecMacEN2.bccf664d.png";